import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthenticationService, AlertService } from '../_services';
import { Router } from '@angular/router';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private alertService: AlertService,  private router: Router) { }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((err) => {
                if (err.status == 401 || err.status == 403) {
                    this.authenticationService.logout();
                    if (err.url.endsWith("/rest-api/signin")) {
                        const error = 'Usuario o Contraseña inválidos.';
                        this.alertService.error(error);
                        return throwError(error);
                    } else if (err.url.endsWith("/rest-api/refresh")) {
                        this.router.navigate(['/login'])
                        const error = 'Sesión expirada.';
                        this.alertService.error(error);
                    }

                } else if (err.status == 409) {
                    return this.authenticationService.refresh().pipe(
                        switchMap((nuevoToken: string) => {
                          // Clonar la solicitud fallida y agregar el nuevo token en los headers
                          const requestClonada = request.clone({
                            setHeaders: { Authorization: `Bearer ${nuevoToken}` }
                          });
                          // Volver a enviar la solicitud con el nuevo token
                          return next.handle(requestClonada);
                        }),
                        catchError(err => {
                          return throwError(err);
                        })
                      );

                } else {
                    const error = err.error || err.error.message || err.statusText;
                    this.alertService.error(error);
                    return throwError(error);
                }
            })
        );
    }
}
